import React, {useEffect} from "react";
import {useKeyNumber} from "@App/hooks/api/useKeyNumber";
import {KeyNumber} from "@App/types";
import {KeyNumberApprovalSkeleton} from "@App/Components/Skeletons/KeyNumberApprovalSkeleton";
import {useTranslation} from "react-i18next";

type KeyNumberApprovalProps = {
    onSelectMotorization: (keyNumber: KeyNumber) => void
}

export const KeyNumberApproval = React.memo<KeyNumberApprovalProps>((props: KeyNumberApprovalProps) => {

    const {t} = useTranslation()

    useEffect(() => {
        if (keyNumber != null && !loading) {
            props.onSelectMotorization(keyNumber)
        }
    })

    const {loading, keyNumber, error} = useKeyNumber();

    if (loading) {
        return (
            <KeyNumberApprovalSkeleton />
        )
    }

    if (error) {
        return <div>{t('keyNumberApproval.error')}</div>
    }

    return (
        <div>
            {keyNumber && (
                <div className="w-full md:w-1/3 border-2 border-tertiary rounded-lg p-5 mt-6">
                    <b>{t('keyNumberApproval.headline')}</b><br/>
                    <div>
                        {keyNumber.brand.name} {keyNumber.generation.name}
                    </div>
                    <div>
                        HSN/TSN: {keyNumber.name}
                    </div>
                </div>
            ) || (
                <div className="w-full md:w-1/3 border-2 border-tertiary rounded-lg p-5 mt-6">
                    <b>{t('keyNumberApproval.no-vehicle-found')}</b><br/>
                    <small>{t('keyNumberApproval.no-vehicle-found-tip')}</small>
                </div>
            )}
        </div>
    )
})
